<template>
  <v-dialog v-model="dialog" scrollable width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        aria-label="Endre tabellkolonner"
        class="ml-2 mr-2 mt-2 mr-2"
        depressed
        v-on="on"
      >
        <v-icon>mdi-table-cog</v-icon>Tabellkolonner
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline">
        Endre tabellkolonner
      </v-card-title>
      <v-card-subtitle class="text-body-1 pt-2"
        >Velg hvilke kolonner som skal være synlige i tabellen ved å krysse av i
        sjekkboksene under.</v-card-subtitle
      >

      <v-card-text>
        <v-tabs color="primary" v-model="tabs">
          <v-tab class="ml-2" ripple color="primary" @keyup.space="tabs = 0">
            NVE tidsserier
          </v-tab>
          <v-tab ripple @keyup.space="tabs = 1">
            Andre tidsserier
          </v-tab>

          <v-tab-item class="pa-4">
            <v-checkbox
              dense
              v-for="col in vheaders"
              input-value="value"
              :key="col.value"
              hide-details
              class="pa-0 ma-0"
              v-model="selectedColumnsCopy"
              :label="col.text"
              :value="col"
            ></v-checkbox>
          </v-tab-item>

          <v-tab-item class="pa-4">
            <v-checkbox
              dense
              v-for="col in otherTimeseriesHeaders"
              :key="col.value"
              hide-details
              class="pa-0 ma-0"
              v-model="selectedColumnsOtherActorsCopy"
              :label="col.text"
              :value="col"
            ></v-checkbox>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn text @click="closeDialog">
          Avbryt
        </v-btn>
        <v-btn color="primary" text @click="saveColumns">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "TheColumnSelector",
  data: () => {
    return {
      dialog: false,
      selectedColumnsCopy: [],
      selectedColumnsOtherActorsCopy: [],
      tabs: null,
    };
  },
  watch: {
    dialog: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedColumnsCopy = JSON.parse(
          JSON.stringify(this.selectedColumns)
        );
        this.selectedColumnsOtherActorsCopy = JSON.parse(
          JSON.stringify(this.selectedColumnsOtherActors)
        );
      }
    },
  },
  computed: {
    ...mapState([
      "vheaders",
      "otherTimeseriesHeaders",
      "showStationsFromOtherActors",
    ]),
    selectedColumns: {
      get() {
        return this.$store.state.selectedColumns;
      },
      set(selectedColumns) {
        return this.$store.dispatch("setSelectedColumns", selectedColumns);
      },
    },
    selectedColumnsOtherActors: {
      get() {
        return this.$store.state.selectedColumnsOtherActors;
      },
      set(selectedColumnsOtherActors) {
        return this.$store.dispatch(
          "setSelectedColumnsOtherActors",
          selectedColumnsOtherActors
        );
      },
    },
  },
  methods: {
    saveColumns: function() {
      this.selectedColumns = this.selectedColumnsCopy;
      this.selectedColumnsOtherActors = this.selectedColumnsOtherActorsCopy;
      this.closeDialog();
    },
    closeDialog: function() {
      this.dialog = false;
    },
  },
};
</script>
